import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IVideosContext, VideosContext } from '../../../../videosState/videosContext';
import Item from './components/Item';
import classNames from 'classnames';
import style from './List.module.scss';

const List: React.FC = () => {
	const { videos } = useContext<IVideosContext>(VideosContext);

	const nameHeadingClasses = classNames(style.name, style.heading);
	const developerHeadingClasses = classNames(style.studio, style.heading);
	const categoryHeadingClasses = classNames(style.category, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={developerHeadingClasses}
					translationNameSpace="listing"
					translationKey="studioLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={categoryHeadingClasses}
					translationNameSpace="listing"
					translationKey="categoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{videos.videos.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};

export default List;
